/**
 * Test ID utilities for Slider component
 *
 * Pattern: All test IDs are generated via named setter functions.
 * This ensures consistency between components and tests.
 */

import { generateTestId } from "@client-shared";

/**
 * Generate test ID for slider elements
 * @param identifier - Slider identifier (e.g. "root", "thumb-0")
 * @returns Test ID string
 */
export const setSliderTestId = (identifier: string): string => generateTestId("Slider", identifier);
